import { FC, useEffect, useState } from 'react';
import './SidebarArticlesFilter.scss';
import SidebarFilter from '../../../components/SidebarFilter/SidebarFilter';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { Col, FormCheck, FormGroup, Row } from 'react-bootstrap';
import ReactSelect from "react-select";
import InputDateRange from '../../../components/InputDateRange/InputDateRange';
import { useArticles } from '../../../providers/Articles/ArticlesProvider';
import { useAgentsCategories } from '../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider';
import { useSections } from '../../../providers/Articles/Sections/SectionsProvider';
import { useSubsections } from '../../../providers/Articles/Subsections/SubsectionsProvider';
import { customStyles } from '../../../models/SelectCustomStyles';

interface SidebarArticlesFilterProps { }

// @ts-ignore
export const defaultValues = {
  id: null,
  title: '',
  startDate: '',
  endDate: '',
  category_id: null,
  section_id: null,
  subsection_id: null,
  is_internal: false,
  only_active: null,
} as any;

const SidebarArticlesFilter: FC<SidebarArticlesFilterProps> = () => {
  const [startDate, setStartDate] = useState<any>(moment(new Date()).format('YYYY-MM-01 HH:mm:ss'));
  const [endDate, setEndDate] = useState<any>(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'));
  const [selectedCategories, setSelectedCategories] = useState<any | null>(null);
  const [selectedSection, setSelectedSection] = useState<any | null>(null);
  const [selectedSubsection, setSelectedSubsection] = useState<any | null>(null);
  const [selectedIsInternal, setSelectedIsInternal] = useState<boolean>(false);
  const [selectedOnlyActive, setSelectedOnlyActive] = useState<boolean | null>(null);

  const { handleSubmit, register, setValue } = useForm<any>({ defaultValues });

  const { params, setParams } = useArticles();
  const { categoriesOptions, setParams: setParamsAgentsCategories } = useAgentsCategories();
  const { sectionsOptions, setParams: setParamsSections } = useSections();
  const { subsectionsOptions, setParams: setParamsSubsections } = useSubsections();

  const onSubmit = async (data: any) => {
    const { page: _page, perPage: _perPage, withPaginate: _withPaginate, ...rest } = data;

    const filter = {
      ...rest,
      startDate: data?.startDate ? moment(data.startDate).format('YYYY-MM-DD') : '',
      endDate: data?.endDate ? moment(data.endDate).format('YYYY-MM-DD') : '',
    };

    filter?.id === '' && (filter.id = null);

    setParams((prev: any) => ({
      ...prev,
      filter: { ...(prev?.filter ?? {}), ...filter },
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  }

  useEffect(() => {
    setParamsAgentsCategories({ withPaginate: false, filter: { only_active: true } });
  }, []);

  useEffect(() => {
    setValue('category_id', selectedCategories?.value || null);
    if (!!selectedCategories) {
      setParamsSections({ withPaginate: false, filter: { only_active: true, category_id: selectedCategories?.value } });
    }
  }, [selectedCategories]);

  useEffect(() => {
    setValue('section_id', selectedSection?.value || null);
    !!selectedSection && setParamsSubsections({ withPaginate: false, filter: { only_active: true, section_id: selectedSection?.value } });
  }, [selectedSection]);

  useEffect(() => { setValue('subsection_id', selectedSubsection?.value || null); }, [selectedSubsection]);

  const changeIsInternal = (action: boolean) => {
    setSelectedIsInternal(action);
    setValue("is_internal", action);
  }

  const changeOnlyActive = (value: boolean | null) => {
    setSelectedOnlyActive(value);
    setValue("only_active", value);
  }

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div className="SidebarArticlesFilter" data-testid="SidebarArticlesFilter">
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="id">#ID</label>
              <input
                className="form-control"
                type="number"
                {...register('id')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="title">TÍTULO</label>
              <input
                className="form-control"
                {...register('title')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="category_id">CATEGORIA</label>
              <ReactSelect
                isSearchable
                isClearable
                options={categoriesOptions ?? []}
                value={selectedCategories}
                placeholder="Selecione"
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedCategories(e);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="section_id">SEÇÃO</label>
              <ReactSelect
                isSearchable
                isClearable
                options={sectionsOptions ?? []}
                value={selectedSection}
                placeholder="Selecione"
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedSection(e ?? null);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="subsection_id">SUBSEÇÃO</label>
              <ReactSelect
                isSearchable
                isClearable
                options={subsectionsOptions ?? []}
                value={selectedSubsection}
                placeholder="Selecione"
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedSubsection(e ?? null);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <InputDateRange
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setValue={setValue}
              startLabelText={'DATA INICIAL'}
              endLabelText={'DATA FINAL'}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="form-group-inline d-flex align-items-center flex-nowrap">
              <label className="me-2 mb-0">STATUS</label>
              <FormCheck className="form-check ms-2" inline>
                <input
                  className="form-check-input"
                  type='radio'
                  id="oaAll"
                  name="only_active"
                  onChange={() => changeOnlyActive(null)}
                  checked={selectedOnlyActive === null}
                />
                <label className="form-check-label" htmlFor="oaAll">Todos</label>
              </FormCheck>
              <FormCheck className="form-check" inline>
                <input
                  className="form-check-input"
                  type='radio'
                  id="oaActive"
                  name="only_active"
                  onChange={() => changeOnlyActive(true)}
                  checked={selectedOnlyActive === true}
                />
                <label className="form-check-label" htmlFor="oaActive">Ativos</label>
              </FormCheck>
              <FormCheck className="form-check" inline>
                <input
                  className="form-check-input"
                  type='radio'
                  id="oaInactive"
                  name="only_active"
                  onChange={() => changeOnlyActive(false)}
                  checked={selectedOnlyActive === false}
                />
                <label className="form-check-label" htmlFor="oaInactive">Inativos</label>
              </FormCheck>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="form-group-inline">
              <label htmlFor="is_internal">ARTIGO INTERNO?</label>

              <FormCheck className="form-check ms-2" inline>
                <input
                  className="form-check-input"
                  type='radio'
                  id="cS"
                  value="true"
                  {...register('is_internal')}
                  onChange={(e) => {
                    changeIsInternal(true);
                  }}
                  checked={selectedIsInternal}
                />
                <label className="form-check-label" htmlFor="cS">Sim</label>
              </FormCheck>
              <FormCheck className="form-check" inline>
                <input
                  className="form-check-input"
                  type='radio'
                  id="cN"
                  value="false"
                  {...register('is_internal')}
                  onChange={(e) => {
                    changeIsInternal(false);
                  }}
                  checked={!selectedIsInternal}
                />
                <label className="form-check-label" htmlFor="cN">Não</label>
              </FormCheck>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
}

export default SidebarArticlesFilter;
